import fetch from 'isomorphic-fetch';
import {throwOnResponseError} from '../../utils/createResponseError';

export const getAdyenInit = async ({paymentSessionId, languageCode}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getAdyenInit`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    const initData = await fetch(url, {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    throwOnResponseError(initData);

    return initData.json();
};


export const getAdyenStatus = async ({paymentSessionId, languageCode}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getAdyenStatus`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    const status = await fetch(url, {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    throwOnResponseError(status);

    return status.json();
};
